export const CLERK_PUBLISHABLE_KEY = window.location.host.includes(
  'finalytic.io'
)
  ? 'pk_live_Y2xlcmsuZmluYWx5dGljLmlvJA' // Finalytic prod key
  : window.location.host.includes('vrplatform.app')
    ? 'pk_live_Y2xlcmsudnJwbGF0Zm9ybS5hcHAk' // VRP prod key
    : 'pk_test_Y2xlcmsuc2luY2VyZS5nb2JibGVyLTc2LmxjbC5kZXYk'; // dev key
